import { sensitiveWordScanClsPrefix } from "../../../constants";

export const EVENT_SHOW_HIGH_LIGHT = `${sensitiveWordScanClsPrefix}-show-high-light`;